import ActionsListCitizenshipLoss from 'cancellations/components/search/actions-cancellation-loss-citizenship';
import { CancellationAireCitizenshipLossSearchCrumbs } from 'cancellations/constants/cancellation-aire-citizenship-loss-crumbs';
import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';

const CancellationAireCitizenshipLossSearchPersonPage = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={CancellationAireCitizenshipLossSearchCrumbs} />
      <PersonSearch
        pathname="/cancellazioni/cancellazione-aire/perdita-cittadinanza/cancellazione"
        action={ActionsListCitizenshipLoss}
        isAire
        addedTitle="- Cancellazione da AIRE per Perdita Cittadinanza Italiana"
      />
    </Fragment>
  );
};

CancellationAireCitizenshipLossSearchPersonPage.displayName =
  'Cancellation citizenship loss search person page component';

export default CancellationAireCitizenshipLossSearchPersonPage;
